angular.module('MktzapApp.Directives')

  .directive('loading', ['$http', function ($http) {
    return {
      restrict: 'A',
      link: function (scope, elm, attrs) {
        scope.isLoading = function () {

          if ($http.pendingRequests.length > 0) {

            let showLoading = false;

            for (let i=0; i < $http.pendingRequests.length; i++) {
              if (!$http.pendingRequests[i].url.includes('history/customer-recurrence')) {
                showLoading = true;
              }
            }
            
            return showLoading;
          }

          return false;
        };

        scope.$watch(scope.isLoading, function (v) {
          if (v) {
            elm.show();
          } else {
            elm.hide();
          }
        });
      }
    };
  }]);
